import { Box, Grid, List, ListItem, ListItemText, TextField } from "@mui/material";
import { useRef, useState } from "react";

export default function UserSelectTextField({ onUserSelect, sliceResponse, inputValue, setInputValue, formErrors }) {
    // console.log("sliceResponse: in text field ", sliceResponse);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    // const [selectedId, setSelectedId] = useState("");
    const inputRef = useRef(null);

    const handleInputChange = (e) => {
        const value = e.target.value.toLowerCase();
        setInputValue(value || e.target.value);

        const filtered = sliceResponse?.filter((option) => {
            const name = option?.name?.toLowerCase() || "";
            const phone = option?.phone || "";
            return name.includes(value) || phone.includes(value);
        });

        setFilteredOptions(filtered || []);
        setShowDropdown(true);
    };

    const handleFocus = () => {
        setFilteredOptions(sliceResponse || []);
        setShowDropdown(true);
    };

    const handleOptionClick = (option) => {
        setInputValue(option?.name || option?.phone);
        // setSelectedId(option._id);
        onUserSelect(option._id);
        setShowDropdown(false);
    };

    const handleBlur = () => {
        setTimeout(() => setShowDropdown(false), 150);
    };

    return (
        <div>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                    <Box sx={{ position: "relative" }}>
                        <TextField
                            required
                            label="Search User"
                            inputRef={inputRef}
                            value={inputValue}
                            onChange={handleInputChange}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            variant="outlined"
                            fullWidth
                            error={!!formErrors?.SelectUser}
                            helperText={formErrors?.SelectUser}
                        />
                        {showDropdown && (
                            <List
                                sx={{
                                    position: "absolute",
                                    width: "100%",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    backgroundColor: "white",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                    zIndex: 1301,
                                    marginTop: "4px",
                                    padding: 0,
                                }}
                            >
                                {filteredOptions?.length > 0 ? (
                                    filteredOptions?.map((option) => (
                                        <ListItem
                                            key={option._id}
                                            button
                                            onMouseDown={() => handleOptionClick(option)}
                                            sx={{
                                                "&:hover": { backgroundColor: "#f0f0f0" },
                                                cursor: "pointer",
                                            }}
                                        >
                                            <ListItemText
                                                primary={option?.name || option?.phone}
                                            />
                                            <span style={{ fontSize: 12 }}>
                                                {option?.phone}
                                            </span>
                                        </ListItem>
                                    ))
                                ) : (
                                    <ListItem>
                                        <ListItemText
                                            primary="No results found"
                                            sx={{ color: "#999", fontStyle: "italic" }}
                                        />
                                    </ListItem>
                                )}
                            </List>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}


// import { Box, Grid, List, ListItem, ListItemText, TextField } from "@mui/material";
// import { useRef, useState } from "react";

// export default function UserSelectTextField({ onUserSelect, sliceResponse, userId, }) {
//     console.log("sliceResponse: ", sliceResponse);

//     const [inputValue, setInputValue] = useState(""); // For input field
//     const [filteredOptions, setFilteredOptions] = useState([]); // For filtered results
//     const [showDropdown, setShowDropdown] = useState(false); // Dropdown visibility
//     const [selectedId, setSelectedId] = useState(""); // Tracks selected option's _id
//     console.log("selectedId: ", selectedId);

//     const inputRef = useRef(null);

//     // Handle input changes and filter the dropdown list
//     const handleInputChange = (e) => {
//         // setFormErrors({});

//         const value = e.target.value;
//         setInputValue(value);
//         const data = sliceResponse
//         // Filter options based on input
//         // const filtered = options.filter((option) =>
//         const filtered = data?.filter(
//             (option) =>
//                 option?.name?.toLowerCase()?.includes(value?.toLowerCase()) ||
//             option.phone.includes(value)
//         );
//         setFilteredOptions(filtered);

//         setShowDropdown(true);
//     };

//     // Handle focus to show all options initially
//     const handleFocus = () => {
//         // setFormErrors({});

//         // setFilteredOptions(options); // Show all options on focus
//         setFilteredOptions(sliceResponse); // Show all options on focus
//         setShowDropdown(true);
//     };

//     // Handle selection of an option
//     const handleOptionClick = (option) => {
//         setInputValue(option.name); // Set input field to selected name
//         setSelectedId(option._id); // Store the selected _id
//         onUserSelect(option._id); // Store the selected _id
//         setShowDropdown(false);
//     };

//     // Close dropdown when clicking outside
//     const handleBlur = () => {
//         setTimeout(() => setShowDropdown(false), 150); // Delay to allow selection clicks
//     };


//     return (
//         <div>
//             <Grid container spacing={2} alignItems="center">
//                 <Grid item xs={12} >
//                     <Box sx={{ position: "relative" }}>
//                         <TextField
//                             label="Search User"
//                             inputRef={inputRef}
//                             value={inputValue}
//                             Autocomplete={false}
//                             onChange={handleInputChange}
//                             onFocus={handleFocus} // Show all options on focus
//                             onBlur={handleBlur}
//                             variant="outlined"
//                             fullWidth
//                             // error={!!formErrors.SelectPartner}
//                             // helperText={formErrors.SelectPartner}
//                             InputProps={{
//                                 sx: {
//                                     // borderRadius: "8px",
//                                     // "&:hover": { borderColor: "#007bff" },
//                                 },
//                             }}
//                         />

//                         {/* Dropdown List */}
//                         {showDropdown && (
//                             <List
//                                 sx={{
//                                     position: "absolute",
//                                     width: "100%", // Matches TextField width
//                                     maxHeight: "200px",
//                                     overflowY: "auto",
//                                     backgroundColor: "white",
//                                     border: "1px solid #ccc",
//                                     borderRadius: "4px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
//                                     zIndex: 1301, // High z-index (MUI default modal z-index is 1300)
//                                     marginTop: "4px",
//                                     padding: 0,
//                                 }}
//                             >
//                                 {filteredOptions.length > 0 ? (
//                                     filteredOptions.map((option) => (
//                                         <ListItem
//                                             key={option._id}
//                                             button
//                                             onMouseDown={() => handleOptionClick(option)}
//                                             sx={{
//                                                 "&:hover": { backgroundColor: "#f0f0f0" },
//                                                 cursor: "pointer",
//                                             }}
//                                         >
//                                             <ListItemText
//                                                 primary={
//                                                     option?.name ? option?.name : option?.phone
//                                                 }
//                                             />
//                                             <span style={{ fontSize: 12 }}>{option?.phone}</span>
//                                         </ListItem>
//                                     ))
//                                 ) : (
//                                     <ListItem>
//                                         <ListItemText
//                                             primary="No results found"
//                                             sx={{ color: "#999", fontStyle: "italic" }}
//                                         />
//                                     </ListItem>
//                                 )}
//                             </List>
//                         )}
//                     </Box>
//                 </Grid>
//             </Grid>
//         </div >
//     )
// }
